import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { MaskedInput } from 'shared/components/MaskedInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectUndergroundTimeBusinessFilter } from 'shared/selectors/advancedFilters';
import { EMetroTravelType } from '../../../../../../../packages/api-models/common/json_query';
import { TModifier } from 'shared/types/filters';

const DEFAULT_TIME = 15;

export const UndergroundTimeBusinessContainer: FC = () => {
  const { label, options, value, time } = useSelector(selectUndergroundTimeBusinessFilter);
  const onChange = useFilterChangeCallback();

  const handleTypeChange = useCallback(
    (newType: EMetroTravelType | null) => {
      const modifiers: TModifier[] = [{ action: 'setUndergroundTravelType', arguments: [newType] }];
      if (newType && !time) {
        modifiers.push({ action: 'setUndergroundTravelTime', arguments: [DEFAULT_TIME] });
      } else if (!newType) {
        modifiers.push({ action: 'setUndergroundTravelTime', arguments: [null] });
      }
      onChange.call(null, ...modifiers);
    },
    [onChange, time],
  );

  const handleTimeChange = useDebouncedCallback(
    (raw: string) => {
      const next = raw ? Number(raw) : null;
      onChange({ action: 'setUndergroundTravelTime', arguments: [next] });
    },
    300,
    [onChange],
  );

  const [travelType] = value;

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        <InlineFilter>
          <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleTypeChange} />
        </InlineFilter>
        {travelType !== null && (
          <InlineFilter label="Не более" postfix="мин." dataTestId="undergroundTravelTime">
            <MaskedInput
              inline
              width={50}
              placeholder="15"
              min={1}
              max={300}
              mask={Number}
              value={time ? String(time) : ''}
              onComplete={handleTimeChange}
            />
          </InlineFilter>
        )}
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
